<template>
    <div>
        <!-- 防水阶段费用详情弹窗 -->
        <el-dialog :title="'防水阶段费用详情'" :visible="visibleStage" fullscreen @close="closeDialog"
            :close-on-click-modal="false" append-to-body class="fixed-header-footer-dialog">
            <div class="container scrollable-content">
                <div class="dynamic-cards" v-if="costData && costData.length > 0">
                    <el-card shadow="hover" class="card" v-for="(item, index) in costData" :key="index">
                        <div slot="header" class="clearfix">
                            <span>{{ item.goodsName || ' ' }}费用详情:</span>
                        </div>
                        <!-- 工费明细 -->
                        <div class="clearfix mt-20" v-if="item.costDetails && item.costDetails.length > 0">
                            <span>工费明细:</span>
                        </div>
                        <el-table v-if="item.costDetails && item.costDetails.length > 0" :data="item.costDetails"
                            style="width: 100%" border fit>
                            <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                            <el-table-column prop="num" label="数量" min-width="80">
                                <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="price" label="单价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                            </el-table-column>
                            <!-- 操作列（当flag为true时） -->
                            <el-table-column label="操作" min-width="120" v-if="item.status === 'TO_BE_THE_FINAL'">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="small" @click.stop="deleteReduceItem(scope.row.id)"
                                        v-if="scope.row.flag === 1">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="cost-summary" v-if="item.status === 'TO_BE_THE_FINAL'">
                            <el-row>
                                <el-col :span="24">
                                    <el-button type="primary" size="small"
                                        @click.stop="openReduceDialog(item.id)">扣费项审减</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="cost-summary">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>工费合计:</strong> <span class="text-primary">{{ item.newTotal || 0 }}</span>
                                    </p>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 材料费用 -->
                        <div class="clearfix mt-20" v-if="item.materialDetails && item.materialDetails.length > 0">
                            <span>材料费用:</span>
                        </div>
                        <el-table v-if="item.materialDetails && item.materialDetails.length > 0"
                            :data="item.materialDetails" style="width: 100%" border fit>
                            <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                            <el-table-column prop="num" label="数量" min-width="80">
                                <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="price" label="单价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                            </el-table-column>
                        </el-table>
                        <div class="cost-summary" v-if="item.n">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>材料费用:</strong> <span class="text-primary">{{ item.n || 0 }}</span></p>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 商家费用 -->
                        <div class="clearfix mt-20" v-if="item.merchantFees && item.merchantFees.length > 0">
                            <span>商家费用:</span>
                        </div>
                        <el-table v-if="item.merchantFees && item.merchantFees.length > 0" :data="item.merchantFees"
                            style="width: 100%" border fit>
                            <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                            <el-table-column prop="num" label="数量" min-width="80">
                                <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="price" label="单价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                            </el-table-column>
                            <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                            </el-table-column>
                        </el-table>
                        <div class="cost-summary ">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>商家总费用:</strong> <span class="text-primary">{{ item.y || 0 }}</span></p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="cost-summary mt-20">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>服务工程师:</strong> {{ item.EngineerName || '无' }}</p>
                                    <p><strong>服务工程师手机号:</strong> {{ item.EngineerMobile || '无' }}</p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="cost-summary mt-20">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>实际人工费:</strong> {{ item.laborCostFormula || '无' }}</p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="cost-summary mt-20">
                            <el-row>
                                <el-col :span="24">
                                    <p><strong>此单收入及材料账户余额:</strong> {{ item.laborCostFormula1 || '无' }}</p>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 阶段审核按钮 -->
                        <div class="stage-action-buttons" v-if="item.status === 'TO_BE_THE_FINAL'">
                            <el-button type="primary" size="small" @click.stop="passStage(item.id)">通过</el-button>
                            <el-button type="danger" size="small" @click.stop="refuseStage(item.id)">拒绝</el-button>
                        </div>
                    </el-card>
                </div>
                <div class="dynamic-cards" v-if="areaConfig && areaConfig.length > 0">
                    <el-card shadow="hover" class="card">
                        <div slot="header" class="clearfix">
                            <span>面积电器配置:</span>
                        </div>
                        <div class="card-content">
                            <el-table :data="areaConfig" style="width: 100%" border fit>
                                <el-table-column prop="name" label="名称" min-width="80">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.name }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="area" label="面积(㎡)" min-width="80">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.area }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="productName" label="电器名称" min-width="300" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style="text-align:right;margin-top:10px;font-weight:bold;">
                            总面积：{{ totalArea }} ㎡
                        </div>
                    </el-card>
                </div>
                <div class="dynamic-cards" v-if="evaluateInfoList && evaluateInfoList.length > 0">
                    <div v-for="(item, index) in evaluateInfoList" :key="index">
                        <el-card shadow="hover" class="card" v-if="item.list && item.list.length > 0">
                            <div slot="header" class="clearfix">
                                <span>{{ item.goodsName || '工单详情' }}:</span>
                            </div>
                            <div class="card-content">
                                <el-row v-if="item.list && item.list.length > 0">
                                    <el-col v-for="column in processEvaluateItemList(item.list)" :key="column.id"
                                        style="display: flex;align-items: center;text-align: center;"
                                        :span="getSpan(processEvaluateItemList(item.list).length)">
                                        <strong>{{ column.fieldName }}:</strong>
                                        <span
                                            v-if="['input', 'checkbox', 'radio', 'integerInput', 'decimalInput'].includes(column.inputType)">{{
                                                column.fieldValue }}</span>
                                        <!-- 评分星级 -->
                                        <span v-else-if="column.inputType === 'star'"
                                            style="display: flex;align-items: center;text-align: center;">
                                            <el-rate v-model="column.fieldValue" disabled></el-rate>
                                            <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                                column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                                    column.fieldValue
                                                        == '5' ? '非常好' : '' }}</span>
                                        </span>
                                        <span v-else><time>{{ column.fieldValue }}</time></span>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24" v-if="totalPrice">
                                        <p style="font-weight: bold;color: #ff4949;">工程师费用合计: {{ totalPrice }}</p>
                                    </el-col>
                                </el-row>
                                <!-- 显示该阶段的图片信息 -->
                                <div class="clearfix mt-20" v-if="getStageImageFields(item.list).length > 0">
                                    <span>图片信息:</span>
                                </div>
                                <div class="form-row" v-for="column in getStageImageFields(item.list)" :key="column.id">
                                    <p class="gap-line-border" v-if="column.inputType === 'img'">
                                        <span class="nameStyle">{{ column.fieldName }}:</span>
                                        <span class="gap-line"></span>
                                        <span v-if="column.fieldValue">
                                            <viewer :images="formmaterImage(column.fieldValue)">
                                                <img v-for="src in formmaterImage(column.fieldValue)" :src="src"
                                                    :key="src" class="card-image" />
                                            </viewer>
                                        </span>
                                        <span v-else>暂无图片</span>
                                    </p>
                                </div>
                                <el-row v-if="!item.list || item.list.length === 0">
                                    <el-col :span="24">
                                        <p>暂无数据</p>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="stage-action-buttons"
                                v-if="item.status == 'TO_BE_THE_FINAL' && item.isShow == '2'">
                                <el-button type="primary" size="small" @click.stop="passStageV2(item.id)">通过</el-button>
                                <el-button type="danger" size="small"
                                    @click.stop="refuseStageV2(item.id)">拒绝</el-button>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="dynamic-cards" v-if="historyReasons">
                    <el-card shadow="hover" class="card">
                        <div slot="header" class="clearfix">
                            <span>历史退回原因:</span>
                        </div>
                        <div class="form-row" v-for="(remark, index) in historyReasons.split(',')" :key="index">
                            <p class="gap-line-border">
                                <span> <span class="nameStyle">第{{ index + 1 }}次退回原因:</span>{{ remark }}</span>
                                <span class="gap-line"></span>
                            </p>
                        </div>
                    </el-card>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="text" icon="el-icon-check" size="small" plain v-if="status == 'TO_BE_THE_FINAL'"
                    @click.stop="pass()">通过</el-button>
                <el-button type="text" icon="el-icon-close" size="small" plain v-if="status == 'TO_BE_THE_FINAL'"
                    @click.stop="refuse()">拒绝</el-button>
                <el-button v-if="status != 'TO_BE_THE_FINAL'" type="text" size="small" icon="el-icon-close" plain
                    @click="closeDialog">关闭</el-button> -->
                <el-button type="text" size="small" icon="el-icon-close" plain @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 扣费项审减弹窗 -->
        <el-dialog :title="'扣费项审减'" :visible="showReduceDialog" @close="closeReduceDialog" :close-on-click-modal="false"
            append-to-body>
            <el-form :model="reduceForm" label-width="80px">
                <!-- 填写费用项目 -->
                <el-form-item label="费用项目">
                    <el-input v-model="reduceForm.itemName" placeholder="请输入费用项目"></el-input>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="reduceForm.operationType" placeholder="请选择操作类型" style="width: 100%">
                        <el-option label="增加" value="1"></el-option>
                        <el-option label="扣减" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input v-model.number="reduceForm.amount" type="number" placeholder="请输入金额" min="0"
                        step="10"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeReduceDialog">取消</el-button>
                <el-button type="primary" @click="submitReduce" :loading="loadingReduce">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { passOrRefusedV2, passOrRefusedAcceptanceV2, getWaterProofStage, getWaterProofOrderInfo, addOrReduceMoney, deleteOrReduceMoney } from "@/api/work/waterProof/merchants";
import { DIC } from "@/const/dic";
export default {
    name: "ViewWaterProofStage",
    props: {
        visibleStage: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        infoDetail: {
            type: Object,
            default: () => ({}),
        },
        totalPrice: {
            type: Number,
            default: 0,
        },
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            type: '',
            areaConfig: [], // 添加面积配置数据
            info: {},
            historyReasons: '',
            customsData: null,
            totalArea: '',
            costData: null, // 存放费用计算数据
            loadingCost: false, // 费用计算加载状态
            evaluateInfoList: [], // 存放工单详情列表数据
            // 扣费项审减相关
            showReduceDialog: false, // 扣费项审减弹窗可见性
            reduceForm: {
                itemName: '', // 费用项目
                operationType: '1', // 操作类型：增加/扣减
                amount: '', // 金额
                stageId: '', // 阶段ID
            },
            loadingReduce: false, // 扣费项审减加载状态
            loadingDelete: false, // 删除扣费项加载状态
        };
    },
    computed: {
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;
                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                    this.getCostData(orderId);
                    this.fetchEvaluateInfoList(orderId);
                }
            })
        }
    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleStage 的变化
         * @returns void
         */
        visibleStage(newVal) {
            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;
                    // 获取产品数据
                    const orderId = this.orderId; // 假设产品ID通过路由参数传递
                    if (orderId) {
                        this.costData = null;
                        this.evaluateInfoList = [];
                        this.getCostData(orderId);
                        this.fetchEvaluateInfoList(orderId);
                    }
                })
            }
        }
    },
    methods: {
        // 阶段通过审核
        passStageV2(stageId) {
            this.$confirm("确认通过该阶段？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        id: stageId,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedAcceptanceV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核通过成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.fetchEvaluateInfoList(this.orderId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        // 阶段拒绝审核
        refuseStageV2(stageId) {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {
                        id: stageId,
                        status: 'IN_SERVICE',
                        reason: value
                    }
                    passOrRefusedAcceptanceV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核拒绝成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.fetchEvaluateInfoList(this.orderId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
        },
        // 获取费用计算数据
        getCostData(orderId) {
            this.loadingCost = true;
            getWaterProofStage(orderId).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    // 确保costData始终是数组格式
                    this.costData = Array.isArray(parsedData) ? parsedData : [parsedData];
                }
            }).finally(() => {
                this.loadingCost = false;
            });
        },
        // 阶段通过审核
        passStage(stageId) {
            this.$confirm("确认通过该阶段？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        id: stageId,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核通过成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            // 刷新当前阶段数据
                            this.getCostData(this.orderId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        // 阶段拒绝审核
        refuseStage(stageId) {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {
                        id: stageId,
                        status: 'IN_SERVICE',
                        reason: value
                    }
                    passOrRefusedV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核拒绝成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            // 刷新当前阶段数据
                            this.getCostData(this.orderId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
        },
        pass() {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        declarationId: this.id,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        refuse() {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {
                        declarationId: this.id,
                    }
                    data.status = 'IN_SERVICE';
                    data.reason = this.historyReasons ? this.historyReasons + ',' + value : value;
                    passOrRefusedV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: this.evaluateInfo ? 'AFTER_SALES_EVALUATION' : 'WORK_HANG_CEILING'
            };
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    const area = dynamicColumns.find(item => item.fieldName === '施工面积');
                    this.totalArea = area ? area.fieldValue : '';
                    this.dynamicColumns = dynamicColumns;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            })
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单详情列表数据
         * @returns void
         */
        fetchEvaluateInfoList(orderId) {
            getWaterProofOrderInfo(orderId).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    // 当parsedData为空时，关闭当前组件并通知父组件打开viewOrder组件
                    if (!parsedData || (Array.isArray(parsedData) && parsedData.length === 0)) {
                        // 先触发打开viewOrder事件，确保父组件接收到
                        this.$emit('openViewOrder');
                        // 然后关闭当前弹窗
                        this.$emit("update:visibleStage", false);
                        return;
                    }
                    // 确保evaluateInfoList始终是数组格式
                    this.evaluateInfoList = Array.isArray(parsedData) ? parsedData : [parsedData];
                    // 每个阶段的图片信息已经在模板中直接处理，不需要单独提取到全局数组
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message({
                    showClose: true,
                    message: '获取工单详情失败',
                    type: "error"
                });
            })
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            // 清空弹窗数据
            this.tableData = [];
            this.dynamicColumns = [];
            this.imageFields = [];
            this.info = {};
            this.historyReasons = '';
            this.customsData = null;
            this.evaluateInfoList = [];
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: ''
            };
            this.showReduceDialog = false;
            this.closeReduceDialog();
            this.$emit("update:visibleStage", false);
        },
        /**
         * 
         * @param list 工单详情列表
         * @description 处理工单详情数据
         * @returns Array
         */
        processEvaluateItemList(list) {
            if (!list || list.length === 0) return [];
            // 过滤掉图片类型的字段（图片现在显示在各自阶段中）
            return list.filter(item => item.inputType != '8').map(item => ({
                id: item.id,
                fieldName: item.fieldName,
                inputType: item.dataType ? item.dataType.word : this.getInputType(item.inputType),
                fieldValue: item.dataType && item.dataType.word == 'star' ? parseInt(item.value) : item.value
            }));
        },
        /**
         * 
         * @param list 工单详情列表
         * @description 获取当前阶段的图片字段
         * @returns Array
         */
        getStageImageFields(list) {
            if (!list || list.length === 0) return [];
            // 提取图片类型的字段
            return list.filter(item => item.inputType == '8').map(item => ({
                id: item.id,
                fieldName: item.fieldName,
                inputType: this.getInputType(item.inputType),
                fieldValue: item.value
            }));
        },
        // 打开扣费项审减弹窗
        openReduceDialog(stageId) {
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: stageId
            };
            this.showReduceDialog = true;
        },
        // 关闭扣费项审减弹窗
        closeReduceDialog() {
            this.showReduceDialog = false;
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: ''
            };
        },
        // 提交扣费项审减
        submitReduce() {
            if (!this.reduceForm.amount || this.reduceForm.amount <= 0) {
                this.$message({
                    showClose: true,
                    message: '请输入有效的金额',
                    type: 'error'
                });
                return;
            }
            this.loadingReduce = true;
            const data = {
                remarks: this.reduceForm.itemName, // 费用项目
                orderId: this.reduceForm.stageId,
                type: this.reduceForm.operationType,
                amount: this.reduceForm.amount
            };
            addOrReduceMoney(data).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "扣费项审减操作成功",
                        type: "success"
                    });
                    this.showReduceDialog = false;
                    this.closeReduceDialog();
                    // 刷新费用数据
                    this.getCostData(this.orderId);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).finally(() => {
                this.loadingReduce = false;
            });
        },
        // 删除扣费项
        deleteReduceItem(id) {
            this.$confirm("确认删除该扣费项？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.loadingDelete = true;
                deleteOrReduceMoney(id).then(res => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success"
                        });
                        this.closeReduceDialog();
                        // 刷新费用数据
                        this.getCostData(this.orderId);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "error"
                        });
                    }
                }).finally(() => {
                    this.loadingDelete = false;
                });
            }).catch(() => { });
        },
    },
};
</script>
<style scoped>
/* 自定义全屏弹窗样式，固定顶部和底部 - 使用样式穿透 */
.fixed-header-footer-dialog {
    z-index: 20;
    display: flex;
    flex-direction: column;
}

/* 使用样式穿透修改Element UI弹窗头部 */
.fixed-header-footer-dialog::v-deep .el-dialog__header {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 使用样式穿透修改Element UI弹窗主体 */
.fixed-header-footer-dialog::v-deep .el-dialog__body {
    position: absolute;
    top: 60px;
    bottom: 60px;
    left: 0;
    right: 0;
    padding: 0;
    overflow: hidden;
}

/* 使用样式穿透修改Element UI弹窗底部 */
.fixed-header-footer-dialog::v-deep .el-dialog__footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    padding: 15px 20px;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
    text-align: right;
}

.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.scrollable-content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 20px;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
}

.mt-20 {
    margin-top: 20px;
}

.text-primary {
    color: #1890ff;
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.cost-summary {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-top: 1px solid #ebeef5;
}

.cost-summary p {
    margin: 8px 0;
    font-size: 14px;
}

.stage-action-buttons {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .form-row {
        flex-direction: column;
    }

    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }

    .cost-summary {
        padding: 10px;
    }

    .cost-summary p {
        font-size: 13px;
    }

    /* 表格在小屏幕上的优化 */
    .el-table {
        font-size: 12px;
        overflow-x: auto;
        display: block;
    }

    .el-table__header-wrapper,
    .el-table__body-wrapper {
        width: 100%;
        overflow-x: auto;
    }

    .el-table-column {
        min-width: 80px !important;
    }
}
</style>